/* eslint-disable no-new */
import { KeenSliderNavigation } from "./keen-slider-navigation-plugin";
import KeenSlider from "keen-slider";

// todo: legacy code - rewrite to use global slider

export const buildFeaturedBlogSection = () => {
  document
    .querySelectorAll("[js-featured-blog-slider]")
    .forEach(function (sliderWrapper) {
      const keenSliderEl = sliderWrapper.querySelector(".keen-slider");
      const dots = sliderWrapper.querySelector("[data-dots]");
      if (!keenSliderEl) return;

      new KeenSlider(
        keenSliderEl,
        {
          breakpoints: {
            "(min-width: 750px)": {
              slides: {
                perView: 2,
                spacing: 15,
              },
            },
          },
          slides: {
            origin: "center",
            perView: 1,
            spacing: 15,
          },
        },
        [
          KeenSliderNavigation({
            arrows: false,
            dots,
            wrapper: sliderWrapper.querySelector(
              ".keen-slider__navigation-wrapper"
            ),
          }),
        ]
      );
    });
};
